@if (privacyPolicyService.isPrivacyTermsDisplayed()) {
<div class="privacy-holder">
    <div class="privacy-text">
        @if (isLogin) {
        <span>{{ 'privacyPolicyLogin' | translate }}</span>
        } @if (!isLogin) {
        <span>{{ 'privacyPolicy' | translate }}</span>
        }
    </div>
    <label class="checkbox-label" [formGroup]="formGroup">
        <input type="checkbox" formControlName="privacyPolicyAccepted" name="privacyPolicyAccepted" />
        {{ 'I accept the' | translate }}
        <a href="{{ privacyPolicyService.getPrivacyTermsLink() }}" target="_blank">{{ 'privacy terms' | translate }}</a>
    </label>
</div>
}
